import { render, staticRenderFns } from "./PostPdfImmoAncien.vue?vue&type=template&id=3aaeb7af&"
import script from "./PostPdfImmoAncien.vue?vue&type=script&lang=js&"
export * from "./PostPdfImmoAncien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports